import { t } from "@travily/i18n";
import type Account from "@travily/types/models/Account";
import { Icon } from "@ui/components/Icon";
import { TopBarBorder } from "@ui/components/TopBar/TopBarBorder";
import { Button } from "@ui/primitives/Button";
import { AccountAvatar } from "@/components/AccountAvatar/AccountAvatar";

interface ConversationTopBarProps {
  account: Account;
  onBack: () => void;
}

/**
 * Mobile bar for an open conversation. Not `TopBarMobile`: that component's centre slot reserves a
 * fixed trailing actions box and widens its gaps for the search pill, which leaves this bar's
 * avatar and name adrift. It mirrors `TopBarMobile`'s shell classes instead so the safe-area inset
 * and bar height stay in step.
 */
export function ConversationTopBar({ account, onBack }: ConversationTopBarProps) {
  return (
    <header className="flex flex-col bg-white pt-safe">
      <div className="flex h-14 w-full items-center gap-3 px-5 py-3">
        <Button
          aria-label={t("common.actions.back")}
          className="flex shrink-0 cursor-pointer items-center outline-none focus-visible:rounded focus-visible:ring-2 focus-visible:ring-neutral-400"
          onPress={onBack}
        >
          <Icon name="arrowLeft" size="20" />
        </Button>
        <AccountAvatar account={account} shape="circle" size="32" />
        <span className="truncate font-semibold text-base text-neutral-900">{account.display_name}</span>
      </div>
      <TopBarBorder />
    </header>
  );
}
